import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";

import { BranchDetails } from "features/BranchDetails";
import { PageTitle } from "shared/ui/PageTitle";

const BranchDetailsPage = () => {
    const { branchId } = useParams<{ branchId: string }>();

    return (
        <>
            <Helmet title="Ресторан" />
            <PageTitle>Ресторан</PageTitle>
            <BranchDetails branchId={Number(branchId)} />
        </>
    );
};

export default BranchDetailsPage;
